import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import Invoices from 'components/Invoice/Invoices';
import InvoicesBank from 'components/Invoice/InvoicesBank';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from "react-virtualized";
import {connect}  from  "react-redux";

function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

class Transaction extends Component{
    constructor(props) {
        super(props);
        this.state ={
            tabsPermissionsArray:[],
            allTabs:["invoice_merchants", "invoice_banks", "invoice_finance"],
            tabsPermissions:[],
            matchedTabs:'',
            merchantList: [],
            chainList: [],
            merchantID: [],
            chainID: [],
            monthID: '042020',
            is_download:true,
            user_id:'',
            merchant_name:'Reliance Retail Limited',
            acqBankList: [],
            acqBankValue: null,
            acqBankIds: [],
            selected_tab:'Summary',
            merchantValue:null,
            chainValue:null,
            defaultSelected:[],
            monthOptions:[],
            storeID: [],
            storeValue:'',
            storeList:[],
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const tabsPermissions = localStorage.tabsPermissions;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            tabsPermissionsArray:tabsPermissions,
            user_id:decoded._id
        });
        this.tabsPermission();
        this._getAllMerchants();
        this.getInvoiceMonth();
        this._getAcqBanks();
        //const parse_data = JSON.parse(decoded.user_info);
        //console.log(parse_data.object_type);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            //this.get_filtered_data('', '', this.state.monthID);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Acquiring Bank') {

            var optionSelected = [{"value":arrayCode, "label":"" }]
            this.change_acq_banks(optionSelected);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: false,
            })
        }

    }

    _getAcqBanks(){
        axios.get(config.get('API_URL') + '/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if (Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
    }
    getInvoiceMonth(){
        axios.get(config.get('API_URL')+'/invoice/get_months/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

           this.enabled_months(response.data);
        });
    }
    enabled_months(emonths) {
        this.setState({
            defaultSelected:[],
            monthOptions:[]
        });


       var defaultSelectedArray = [];
       var monthOptionsArray= [];
        for(var i=0; i<=11; i++){
            let date2 = new Date();
            let monthd = date2.setMonth(date2.getMonth() -i);
            date2 = date2.toDateString();
            date2 = new Date(date2);
            let month2 = getMonth(date2);
            let year2 = date2.getFullYear();
            let monthName2 = monthNames[date2.getMonth()];
            var isDisable = true;
            if(emonths.includes(month2+year2)===true){
                isDisable = false;
                defaultSelectedArray.push({ value: month2+year2, label: monthName2+' '+year2})
            }

            monthOptionsArray.push({ value: month2+year2, label: monthName2+' '+year2, isDisabled: isDisable})
        }

        this.setState({
            defaultSelected:defaultSelectedArray,
            monthOptions:monthOptionsArray
        })
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL') + '/reports/get-merchant/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    changeMerchant(login_type, optionSelected) {
        let value = '';
        let midArray = [];
        if (optionSelected.length < 1) {
            value = null;
            midArray = '';
        } else {
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID: midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue: [],
            storeID:'',
            storeValue: []
        });
        setTimeout(function(){
            this.refs.childInvoices.get_filtered_invoices(midArray, this.state.chainID, this.state.storeID, this.state.monthID);
        }.bind(this), 200);

        if (login_type == '') {
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }
    }

    changeChain(login_type, optionSelected) {
        let value = '';
        let cidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            cidArray = '';
        } else {
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue: optionSelected,
            storeID: '',
            storeValue: []
        });
        setTimeout(function(){
            this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID);
        }.bind(this), 200);


        if (login_type == '') {
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }

    getChain(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-chain/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID: ''});
            response.data.map((chain, index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList: chalinList
            })
        });
    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID: ''});
            response.data.map((store, index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList: storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value = '';
        let sidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            sidArray = '';
        } else {
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue: optionSelected
        });
        setTimeout(function(){
            this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID);
        }.bind(this), 200);

    }


    changeMonth(type, optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        //alert(value);
        this.setState({
            monthID: value
        });
        if(type=='merchant'){
            this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, value);
        }
        if(type=='bank'){
            //this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID,  this.state.storeID, value);
            this.refs.childInvoicesBank.get_filtered_data_bank(this.state.acqBankIds, value);
        }
    }



    tabsPermission(){
        const token = localStorage.usertoken;
        let tabsPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllaccessPermissions = decoded_permission.accessPermissions;
        AllaccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Tab'){
                tabsPermissions.push(permissionName.access_name);
            }
        });
        this.setState({
            tabsPermissions:tabsPermissions,
        });
        this.getMatch(tabsPermissions,this.state.allTabs);

    }
    getMatch(a, b) {
        var matches = [];
        for ( var i = 0; i < a.length; i++ ) {
            for ( var e = 0; e < b.length; e++ ) {
                if ( a[i] == b[e] ) matches.push( a[i] );
            }
        }
        //alert(matches.length);
        this.setState({
            matchedTabs:matches.length
        })
    }

    cancelReqBank(){
        this.state.xhrBank.abort();
        this.setState({
            is_download:true
        })
    }



    change_acq_banks(optionSelected) { //console.log(optionSelected);
        let value = '';
        let acqBankArray = [];
        if (optionSelected.length < 1) {
            value = null;
            acqBankArray = '';
        } else {
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value == mids.value);
                this.state.acqBankList.move(index, 0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds: acqBankArray,
            acqBankValue: optionSelected,
        });
        setTimeout(function(){
            this.refs.childInvoicesBank.get_filtered_data_bank(acqBankArray, this.state.monthID);
        }.bind(this), 200);

    }


    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if (rows.length !== undefined) {
                no_of_rows = rows.length;
                if (no_of_rows < 9) {
                    drop_down_heigth = 40 * no_of_rows;
                } else {
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
                <div key={key} style={style}>{rows[index]}</div>
            );
            return (
                <List
                    style={{width: '100%'}}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        let merchantTab='';
        let merchantTabPane='';
        let bankTab='';
        let bankTabPane='';
        let merchantComponent='';
        let bankComponent='';
        let is_any_tab ='N';
        const customStyles = {
            // control: provided => ({
            //     ...provided,
            //     padding:"0px",
            //     minHeight: "15px",
            // }),
            // indicatorsContainer: provided => ({
            //     ...provided,
            //     height: "23px"
            // }),
            // clearIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // dropdownIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // valueContainer: base => ({
            //     ...base,
            //     padding: '0px 6px'
            // }),

        };
        if(this.state.tabsPermissions.includes("invoice_merchants")===true){
            is_any_tab ='Y';
            merchantTab = (
                <Tab style={{ }}>Merchants</Tab>
            );
            merchantTabPane = (
                <TabPanel>
                    <div className="tansactionTabs filterpane">
                        {this.state.merchant_list_box===true?
                            <div className="col-md-3 filter-bottom5 ">
                                <label>Merchants</label>
                                <ReactMultiSelectCheckboxes name="merchants"
                                                            isMulti
                                                            components={{MenuList}}
                                                            value={this.state.merchantValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeMerchant.bind(this, '')}
                                                            options={this.state.merchantList}
                                                            placeholderButtonLabel="Select [Merchant]"
                                />

                                <div className="clearfix"></div>
                            </div> : null}
                        {this.state.chain_list_box===true?
                            <div className="col-md-3 filter-bottom5 padd-5">
                                <label> Chain </label>
                                <ReactMultiSelectCheckboxes name="chain"
                                                            isMulti
                                                            components={{MenuList}}
                                                            value={this.state.chainValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeChain.bind(this, '')}
                                                            options={this.state.chainList}
                                                            placeholderButtonLabel="Select [Chain]"
                                />
                                <div className="clearfix"></div>
                            </div> : null}
                        {this.state.store_list_box===true?
                            <div className="col-md-3 filter-bottom5 padd-5">
                                <label> Store </label>
                                <ReactMultiSelectCheckboxes name="store"
                                                            isMulti
                                                            isLoading={this.state.is_store_loading}
                                                            components={{MenuList}}
                                                            value={this.state.storeValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeStore.bind(this, '')}
                                                            options={this.state.storeList}
                                                            placeholderButtonLabel="Select [Store]"
                                />
                                <div className="clearfix"></div>
                            </div> : null}
                        <div className="col-md-3">
                            <label> Month </label>
                            {/*{this.state.defaultSelected[0]!=undefined ?*/}
                            <Select name="month"
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'merchant')}
                                    options={this.state.monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            {/*: null }*/}
                            <div className="clearfix"></div>
                        </div>

                        <div className="clearfix"></div>
                    </div>
                    <Invoices ref="childInvoices"/>
                    {/*<Tabs forceRenderTabPanel defaultIndex={0}>*/}
                    {/*    <TabList>*/}
                    {/*        <Tab onClick={()=>this.triggerChildAlertInvoices()}>Invoices</Tab>*/}
                    {/*      </TabList>*/}

                    {/*    <TabPanel>*/}
                    {/*       */}
                    {/*    </TabPanel>*/}

                    {/*</Tabs>*/}
                </TabPanel>
            );
            merchantComponent=(

                <Tabs forceRenderTabPanel defaultIndex={0}>
                    <div className="tansactionTabs filterpane top10">
                        {this.state.merchant_list_box===true?
                            <div className="col-md-3 filter-bottom5 ">
                                <label>Merchants</label>
                                <ReactMultiSelectCheckboxes name="merchants"
                                                            isMulti
                                                            components={{MenuList}}
                                                            value={this.state.merchantValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeMerchant.bind(this, '')}
                                                            options={this.state.merchantList}
                                                            placeholderButtonLabel="Select [Merchant]"
                                />

                                <div className="clearfix"></div>
                            </div> : null}
                        {this.state.chain_list_box===true?
                            <div className="col-md-3 filter-bottom5 padd-5">
                                <label> Chain </label>
                                <ReactMultiSelectCheckboxes name="chain"
                                                            isMulti
                                                            components={{MenuList}}
                                                            value={this.state.chainValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeChain.bind(this, '')}
                                                            options={this.state.chainList}
                                                            placeholderButtonLabel="Select [Chain]"
                                />
                                <div className="clearfix"></div>
                            </div> : null}
                        {this.state.store_list_box===true?
                            <div className="col-md-3 filter-bottom5 padd-5">
                                <label> Store </label>
                                <ReactMultiSelectCheckboxes name="store"
                                                            isMulti
                                                            isLoading={this.state.is_store_loading}
                                                            components={{MenuList}}
                                                            value={this.state.storeValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.changeStore.bind(this, '')}
                                                            options={this.state.storeList}
                                                            placeholderButtonLabel="Select [Store]"
                                />
                                <div className="clearfix"></div>
                            </div> : null}
                        <div className="col-md-3">
                            <label> Month </label>
                            <Select name="month"
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'merchant')}
                                    options={this.state.monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />

                            <div className="clearfix"></div>
                        </div>

                        <div className="clearfix"></div>
                    </div>
                    <Invoices ref="childInvoices"/>
                    {/*<TabList>*/}
                    {/*    <Tab onClick={()=>this.triggerChildAlertInvoices()}>Invoices</Tab>*/}
                    {/*</TabList>*/}

                    {/*<TabPanel>*/}
                    {/*    <Invoices ref="childInvoices"/>*/}
                    {/*</TabPanel>*/}

                </Tabs>

            );
        }
        if(this.state.tabsPermissions.includes("invoice_banks")===true){
            is_any_tab ='Y';
            bankTab = (
                <Tab style={{ }}>Banks</Tab>
            );
            bankTabPane = (
                <TabPanel>
                    <div className="tansactionTabs filterpane row">
                        {this.state.acq_bank_list_box===true?
                        <div className="col-md-3">
                            <label> Banks </label>
                            <ReactMultiSelectCheckboxes name="acqurier"
                                                        isMulti
                                                        value={this.state.acqBankValue}
                                                        styles={customStyles} className="report-listbox"
                                                        isClearable={false}
                                                        onChange={this.change_acq_banks.bind(this)}
                                                        options={this.state.acqBankList}
                                                        placeholderButtonLabel="Select [Acquirer]"
                            />
                            <div className="clearfix"></div>
                        </div> : null }
                        <div className="col-md-3">
                            <label > Month </label>
                            <Select name="month"
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'bank')}
                                    options={this.state.monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    {/*<Tabs forceRenderTabPanel defaultIndex={0}>*/}
                    {/*    <TabList>*/}
                    {/*        <Tab onClick={()=>this.triggerChildAlertInvoices()}>Invoices</Tab>*/}
                    {/*    </TabList>*/}
                    {/*    <TabPanel>*/}
                    {/*        <Invoices ref="childInvoices"/>*/}
                    {/*    </TabPanel>*/}
                    {/*</Tabs>*/}
                    <InvoicesBank ref="childInvoicesBank"/>
                </TabPanel>
            );
            bankComponent=(
                <Tabs forceRenderTabPanel defaultIndex={0}>
                    <div className="tansactionTabs filterpane top10">
                        {this.state.acq_bank_list_box===true?
                            <div className="col-md-3">
                                <label> Banks </label>
                                <ReactMultiSelectCheckboxes name="acqurier"
                                                            isMulti
                                                            value={this.state.acqBankValue}
                                                            styles={customStyles} className="report-listbox"
                                                            isClearable={false}
                                                            onChange={this.change_acq_banks.bind(this)}
                                                            options={this.state.acqBankList}
                                                            placeholderButtonLabel="Select [Acquirer]"
                                />
                                <div className="clearfix"></div>
                            </div> : null }
                        <div className="col-md-3">
                            <label> Month </label>
                            <Select name="month"
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'bank')}
                                    options={this.state.monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                      
                    </div>

                    <InvoicesBank ref="childInvoicesBank"/>
                </Tabs>
            );
        }


        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="content-invoice">
                                    {this.state.matchedTabs>1?
                                        <Tabs>
                                            <TabList>
                                                {merchantTab}
                                                {bankTab}
                                                {/*{financeTab}*/}
                                            </TabList>

                                            {merchantTabPane}
                                            {bankTabPane}
                                            {/*{financeTabPane}*/}
                                        </Tabs>:
                                        <div>
                                            {merchantComponent}
                                            {bankComponent}
                                            {/*{financeComponent}*/}
                                            {
                                                is_any_tab=='N'? <div className="col-md-12 top10">You don't have permission to view this Page</div>:null
                                            }
                                        </div>
                                    }
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
     
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( Transaction )